import PlayCircleFilledSharpIcon from '@mui/icons-material/PlayCircleFilledSharp';
import { styled } from '@mui/material/styles';

const StyledBackground = styled('div')`
  border-top: 3.5px solid transparent;
  border-bottom: 3.5px solid transparent;
  border-left: 4.5px solid white;
  margin-left: 1px;
  position: absolute;
  z-index: 1;
  opacity: 1;
`;

export const PlayIconWithBackground = () => {
  return (
    <>
      <PlayCircleFilledSharpIcon fontSize="medium" />
      <StyledBackground />
    </>
  );
};
